// Question definitions for the SCS "Post-Marketing Data" wizard.
//
// Mirrors scsAnalysisOfAdverseEventsQuestions / scsSafetyInSpecialGroups
// Questions — the pages ask the same shaped questions (whether there is
// anything to report, then which table reports it), so they share attribute
// names wherever the answer is the same answer: `number` is the stable badge
// shown in the CSR-style index badge (page order, hardcoded — it does not
// renumber as conditional sections toggle), `text` is the fallback wording and
// `tooltip` holds the ticket INFORMATION/helper text (the endpoint returns
// wording only, no tooltip map).
//
// At runtime the wording is overridden by
// GET /clinical_summaries/safety_summary/questions, keyed by the same attribute
// the answer is stored under. `textKey` names the attribute to read that
// wording from when it differs from the local key.

export const SCS_PMD_QUESTIONS = {
  qPostMarketing: {
    number: 1,
    required: true,
    text: "Has this drug been marketed anywhere in the world?",
  },
  qPostMarketingTable: {
    number: 2,
    text: "Identify the post-marketing data table.",
    tooltip:
      "TriloDocs reproduces the table as-is: country, product name, approximate doses/patients exposed. No analysis is applied.",
  },
};

// Yes / No toggle answers for question 1 (same shape as the Subject Disposition
// Q1 options).
export const SCS_PMD_MARKETED_OPTIONS = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

// Answering "No" to Q1 ends the section: no table is reported and this standard
// wording is what gets written into the section instead. The "[drug name]"
// placeholders are left in place — they are substituted when the section is
// generated, so the text is stored (and shown) exactly as it is written here.
export const SCS_PMD_NOT_MARKETED_TEMPLATE =
  "There is no post-marketing data on [drug name] as it is not marketed in " +
  "any country in the world. Thus, all safety data provided in this " +
  "submission are from clinical studies conducted with [drug name].";
